import baseHttp from "./baseHttp";

export const getWebPushConfig = () => baseHttp.get("/api/v1/partner/web-push/config").then((r) => r.data);
export const saveWebPushSubscription = (subscription) => {
  const json = subscription.toJSON();
  return baseHttp.post("/api/v1/partner/web-push/subscriptions", {
    endpoint: json.endpoint,
    keys: json.keys,
    content_encoding: "aes128gcm",
    user_agent: navigator.userAgent,
    device_name: `Windows POS — ${navigator.platform || "Navigateur"}`,
  }).then((r) => r.data);
};
